export default "__VITE_ASSET__78d65e58__"